import domainMap from '../domains';
import type { DomainMapper } from '../domains/types';

export type { DomainMapper, FeatureSettings, CustomerTypeSettings } from '../domains/types';

export const findDomainByHostAndPath = (hostname: string | undefined, path: string | undefined): DomainMapper | null => {
  let foundDomain = null as null | DomainMapper;
  const foundDomains = domainMap.filter((d) => d.domain === hostname);

  if (foundDomains.length > 1) {
    const nonSubFolderDomain = foundDomains.find((d) => !d.subFolder);
    if (nonSubFolderDomain) {
      foundDomain = nonSubFolderDomain;
    } else {
      const normalizedPath = path?.split('/').filter((str) => str.length).shift();
      const matchedByPath = foundDomains.find((d) => d.storyblokBasePath === normalizedPath) || null;
      if (matchedByPath) {
        foundDomain = matchedByPath;
      } else {
        [foundDomain] = foundDomains;
      }
    }
  } else {
    foundDomain = foundDomains[0] ?? domainMap[0] ?? null;
  }

  return foundDomain;
};

export const getMarketsByEnvironment = (environment: string): DomainMapper[] | null => {
  return domainMap.filter((d) => d.environment === environment);
};

/**
 * Fallback strategies
 * If host name is matched but not language, ex /fi but we only have /se /no,
 * it will fall back to the first entry, so place fallback language first
 * We need a fallback language to display 404 page
 */
export default domainMap;
